import { useTitle } from "#/utils/useTitle"

export default function Layout({ children }: { children?: React.ReactNode }) {
  useTitle('填写资料')
  return <div className="w-full h-full pt-safe">{children}</div>
}
